import { Component, ElementRef, NgZone, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import  { AuthService } from "../../../services/auth.service"
import { Router } from '@angular/router';
import { ThemeService } from 'src/app/theme.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  // loginForm: FormGroup
  // isLoading = false
  // error: string | null = null

  // constructor(
  //   private fb: FormBuilder,
  //    private authService: AuthService,
  //   private router: Router,
  //   private themeService: ThemeService,   private renderer: Renderer2,
  //   private el: ElementRef,
  //   private ngZone: NgZone,
  // ) {
  //   this.loginForm = this.fb.group({
  //     email: ["", [Validators.required, Validators.email]],
  //     password: ["", [Validators.required]],
  //     rememberMe: [false],
  //   })
  // }

  // ngOnInit(): void {
   
  //     this.authService.initGoogleLogin();
  //     const savedTheme = localStorage.getItem('theme') === 'dark'; // Check if the saved theme is dark
  //     // this.themeService.isDarkMode$.next(savedTheme); // Update BehaviorSubject with saved theme
    
  //     this.applyTheme(savedTheme); // Apply theme immediately
    
  //     console.log('theme:', savedTheme); // Debugging
    
  //     // Listen for theme changes and apply them dynamically
  //     this.themeService.isDarkMode$.subscribe((isDarkMode) => {
  //       this.applyTheme(isDarkMode);
  //     });
  //   // Check if user is already logged in
  //   // if (this.authService.isLoggedIn()) {
  //   //   this.router.navigate(["/dashboard"])
  //   // }
  // }

  // private applyTheme(isDark: boolean): void {
  //   const savedTheme = localStorage.getItem('theme') || 'light'; // Default to light
  //   document.body.classList.toggle('dark', savedTheme === 'dark');
  //   if (isDark) {
  //     this.renderer.addClass(this.el.nativeElement, "dark-theme")
  //     this.renderer.removeClass(this.el.nativeElement, "light-theme")
  //   } else {
  //     this.renderer.addClass(this.el.nativeElement, "light-theme")
  //     this.renderer.removeClass(this.el.nativeElement, "dark-theme")
  //   }
  // }

  // loginWithGoogle(): void {
  //   // this.isLoading = true
  //   // this.error = null

  //   // this.authService.loginWithGoogle().subscribe({
  //   //   next: () => {
  //   //     this.router.navigate(["/dashboard"])
  //   //   },
  //   //   error: (err) => {
  //   //     this.error = err.message || "An error occurred during Google login"
  //   //     this.isLoading = false
  //   //   },
  //   //   complete: () => {
  //   //     this.isLoading = false
  //   //   },
  //   // })
  // }
  // // googleLogin() {
  // //   this.authService.signIn().subscribe({
  // //     next: (user) => {
  // //       console.log("Google Sign-In Successful", user);
  
  // //       // this.authService.handleGoogleLogin(user).subscribe({
  // //       //   next: (response) => {
  // //       //     if (response.success) {
  // //       //       this.router.navigate(["/chat"]);
  // //       //     } else {
  // //       //       this.errorMessage = response.message;
  // //       //     }
  // //       //   },
  // //       //   error: (error) => {
  // //       //     console.error("Google login failed:", error);
  // //       //     this.errorMessage = "Google login failed. Please try again.";
  // //       //   },
  // //       // });
  // //     },
  // //     error: (error) => {
  // //       console.error("Google Sign-In Error", error);
  // //       // this.errorMessage = "Google sign-in failed. Please try again.";
  // //     },
  // //   });
  // // }
  
  // onSubmit(): void {
  //   if (this.loginForm.invalid) return;
  
  //   this.isLoading = true;
  //   this.error = null;
  
  //   const { email, password } = this.loginForm.value;
  
  //   this.authService.login(email, password).subscribe(
  //     (response) => {
  //       console.log('Login successful:', response);
  //       this.isLoading = false;
  
  //       // Store token if available
  //       if (response.token) {
  //         localStorage.setItem('token', response.token);
  //       }
  
  //       // Check user role
  //       if (response.user && response.user.role) {
  //         if (response.user.role === 'school_admin') {
  //           this.router.navigate(['/admin/dashboard']); // Navigate to admin dashboard
  //         } else {
  //           this.router.navigate(['/dashboard']); // Navigate to regular dashboard
  //         }
  //       } else {
  //         this.router.navigate(['/dashboard']); // Fallback navigation
  //       }
  //     },
  //     (error) => {
  //       console.error('Login failed:', error);
  //       this.isLoading = false;
  //       this.error = 'Invalid email or password!';
  //     }
  //   );
  // }
  

  
  showLogin = false
  email = ""
  password = ""
  showPassword = false
  headingWords: { text: string; delay: number }[] = []
  subtitleWords: { text: string; delay: number }[] = []
  loadingProgress = 0
  audioPlaying = false
  userInteracted = false
  @ViewChild("headingRef") headingRef!: ElementRef

  // showLogin = false
  // email = ""
  // password = ""
  // showPassword = false
  // headingWords: { text: string; delay: number }[] = []
  // subtitleWords: { text: string; delay: number }[] = []
  // loadingProgress = 0
  isMuted = false

  private audioElement: HTMLAudioElement | null = null
  private loadingInterval: any
  private headingText = "Redefining Learning for the AI Age"
  private subtitleText = "Personalized. Efficient. Made for success."
  greetingMessage: string = '';

  constructor(private router: Router,  private authService: AuthService,) {
    // this.checkAudioPermission();
  }

  ngOnInit(): void {
    const isFirstVisit = localStorage.getItem('hasVisited');

    if (!isFirstVisit) {
      this.greetingMessage = 'Hello!';
      // Set the flag in localStorage after first visit
      localStorage.setItem('hasVisited', 'true');
    } else {
      this.greetingMessage = 'Hello Again!';
    }
    this.initializeWordAnimations()
    // this.initializeAudio()
    this.startLoadingAnimation()
  }

  ngAfterViewInit(): void {
    // Any code that needs to run after the view is initialized
  }

  ngOnDestroy(): void {
    if (this.audioElement) {
      this.audioElement.pause()
      this.audioElement.currentTime = 0
      this.audioElement = null
    }

    if (this.loadingInterval) {
      clearInterval(this.loadingInterval)
    }
  }

  private initializeWordAnimations(): void {
    // Split heading into words and create animated elements
    this.headingWords = this.headingText.split(" ").map((word, index) => ({
      text: word + (index < this.headingText.split(" ").length - 1 ? "\u2009" : ""),
      delay: 1.2 + index * 0.1
    }));
    
    

    // Split subtitle into words and create animated elements with a longer delay
    this.subtitleWords = this.subtitleText.split(" ").map((word, index) => ({
      text: word + (index < this.subtitleText.split(" ").length - 1 ? "\u00A0" : ""),
      delay: 1.2 + index * 0.1,
    }))
  }
  private checkAudioPermission(): void {
    const userPermission = localStorage.getItem('audioPermission');
    
    if (userPermission === 'granted') {
      this.initializeAudio(); // Play audio immediately if permission is granted
    } else {
      this.askForAudioPermission(); // Otherwise, ask for permission
    }
  }
  
  private askForAudioPermission(): void {
    // Show a modal or prompt asking for audio permission
    if (confirm("We would like to play some background audio. Do you allow it?")) {
      // User granted permission
      localStorage.setItem('audioPermission', 'granted');
      this.initializeAudio();
    } else {
      // User denied permission
      localStorage.setItem('audioPermission', 'denied');
      console.log("User denied audio permission");
    }
  }
  
  private initializeAudio(): void {
    this.audioElement = new Audio("/assets/Audio/ScholarX - loading page audio.mp3");
    
    if (this.audioElement) {
      this.audioElement.volume = 0.5;
  
      // Attempt to play audio and handle any errors (if autoplay is blocked)
      const playPromise = this.audioElement.play();
  
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log("Audio is playing.");
          })
          .catch((error) => {
            console.log("Autoplay blocked by the browser.");
          });
      }
    }
  }
  // private initializeAudio(): void {
  //   this.audioElement = new Audio("/assets/Audio/ScholarX - loading page audio.mp3")
  //   if (this.audioElement) {
  //     this.audioElement.volume = 0.5

  //     // Play audio when component mounts
  //     const playPromise = this.audioElement.play()

  //     // Handle autoplay restrictions
  //     if (playPromise !== undefined) {
  //       playPromise.catch((error) => {
  //         console.log("Autoplay prevented due to browser restrictions")
  //       })
  //     }
  //   }
  // }

  private startLoadingAnimation(): void {
    this.loadingInterval = setInterval(() => {
      const increment = Math.random() * 3 + 2
      const newProgress = Math.min(100, this.loadingProgress + increment)

      this.loadingProgress = newProgress

      // When loading reaches 100%, show the login screen
      if (newProgress >= 100) {
        clearInterval(this.loadingInterval)

        // Small delay before showing login to make the transition smoother
        setTimeout(() => {
          this.showLogin = true
        }, 300)
      }
    }, 100)
  }

  toggleMute(): void {
    this.isMuted = !this.isMuted
    if (this.audioElement) {
      this.audioElement.muted = this.isMuted
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword
  }

  handleSubmit(): void {
    this.authService.login(this.email, this.password).subscribe(
      (response: any) => {
        console.log('Login successful:', response);
  
        // Store the entire user object
        localStorage.setItem('user', JSON.stringify(response));
  
        // Store token separately
        if (response.token) {
          localStorage.setItem('token', response.token);
        }
  
        // Navigate based on user role
        const role = response.user?.role;
        localStorage.setItem('role', response.user.role);
        console.log('User role:', role);
  
        // Role-based navigation
        switch (role) {
          case 'student':
            this.router.navigate(['/student/chat']);
            break;
          case 'teacher':
            this.router.navigate(['/teacher/dashboard']);
            break;
          case 'school_admin':
            this.router.navigate(['/admin/dashboard']);
            break;
          case 'super_admin':
            this.router.navigate(['/superadmin/dashboard']);
            break;
          default:
            this.router.navigate(['/student/chat']); // Fallback to student
        }
      },
      (error) => {
        console.error('Login failed:', error);
  
        // Show SweetAlert2 error message
        Swal.fire({
          icon: 'error',
          title: 'Login Failed',
          text: error?.error?.message || 'Invalid email or password. Please try again.',
          confirmButtonColor: '#d33'
        });
      }
    );
  }
  
}
